// src/lib/plans.js
// ★ Freeの制限を変えるのはこのファイル1箇所（＋ SQLの plan_project_limit）

export const PRO_PRICE_LABEL = '¥980 / 月（税込）';

export const PLAN_LIMITS = {
  free: {
    maxProjects: 10,      // 案件の累計上限（DBトリガーと数字を揃えること）
    quoteOrderPdf: false, // 見積書兼注文書PDF
    invoicePdf: true,     // 請求書PDF（Freeでも出せる＝コア体験は残す）
    workProof: false,     // 稼働証明書 PDF / Excel
  },
  pro: {
    maxProjects: Infinity,
    quoteOrderPdf: true,
    invoicePdf: true,
    workProof: true,
  },
};

// UpgradeModal に出す文言。reason をキーに引く。
export const UPGRADE_COPY = {
  projects: {
    title: '案件はFreeプランで10件までです',
    desc: 'Proにすると案件を無制限に登録できます。過去の案件を消す必要はありません。',
  },
  quoteOrderPdf: {
    title: '見積書兼注文書の出力はProプランの機能です',
    desc: 'Proにすると見積書兼注文書をPDFで発行し、クライアントに送れます。',
  },
  workProof: {
    title: '稼働証明書の出力はProプランの機能です',
    desc: 'Proにすると稼働証明書をPDF・Excelで出力できます。',
  },
  default: {
    title: 'この機能はProプランで使えます',
    desc: 'Proにすると案件無制限・全書類の出力が解放されます。',
  },
};

export const PRO_FEATURES = [
  '案件の登録数が無制限',
  '見積書兼注文書のPDF発行',
  '稼働証明書のPDF・Excel出力',
  '請求書・経費・収支の管理はそのまま',
];
